
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import LaunchIcon from '@material-ui/icons/Launch';
import { Grid, Button } from '@material-ui/core';
// entities
import { CampaignContact } from '../../../entities/site';

interface ActionButtonsProps {
    contact: CampaignContact;
    hideOpen?: boolean;
    onRefresh(contact: CampaignContact): void;
    onEdit(contact: CampaignContact): void;
    onOpen(contact: CampaignContact): void;
}

const ActionButtons: React.FC<ActionButtonsProps> = (props) => {

    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Button
                color="primary"
                startIcon={<RefreshIcon />}
                onClick={() => props.onRefresh(props.contact)}
            >
                Refresh
              </Button>
            <Button
                color="primary"
                startIcon={<EditIcon />}
                onClick={() => props.onEdit(props.contact)}
            >
                Edit
              </Button>
            {props.hideOpen &&
                <Button
                    color="primary"
                    startIcon={<LaunchIcon />}
                    onClick={() => props.onOpen(props.contact)}
                >
                    Fullscreen
              </Button>
            }
        </div>
    );
};

export default ActionButtons;

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex'
    }
}));


// WEBPACK FOOTER //
// ./src/pages/campaign/components/ActionButtons.tsx